import { Dispatch } from "react";
import AddressesContent from "@Types/addresses";
import Cart, { PaymentMethod, Step } from "@Types/cart";
import Promo from "@Types/promos";
import User from "@Types/user";
import { setCartStep, SetCartStepAction } from "./actions/setCartStep";
import { setDeliveryAddress, SetDeliveryAddressAction } from "./actions/setDeliveryAddress";
import { setDeliveryMode, SetDeliveryModeAction } from "./actions/setDeliveryMode";
import { setDisabledCart, SetDisabledCartAction } from "./actions/setDisabledCart";
import { setDraftsNumber, SetDraftsNumberAction } from "./actions/setDraftsNumber";
import { setSavedAddresses, SetSavedAddressesAction } from "./actions/setSavedAddresses";
import { setSavedCart, SetSavedCartAction } from "./actions/setSavedCart";
import {
  setSelectedPaymentMethod,
  SetSelectedPaymentMethodAction,
} from "./actions/setSelectedPaymentMethod";
import {
  setShippingOptionMethod,
  SetShippingOptionMethodAction,
} from "./actions/setShippingOptionMethod";
import { setUserProfile, SetUserProfileAction } from "./actions/setUserProfile";

export interface InitialCartState {
  addresses: AddressesContent;
  cart: Cart;
  promos: Promo[];
  selectedPaymentMethod: PaymentMethod | undefined;
  ui?: {
    disabled: boolean;
    draftsNumber: number;
    step: Step;
    steps: Step[];
  };
  track?: (name: string) => Promise<void>;
  user: User;
}
export type CartState = Required<InitialCartState>;

export type CartAction =
  | SetCartStepAction
  | SetDeliveryAddressAction
  | SetDeliveryModeAction
  | SetDisabledCartAction
  | SetDraftsNumberAction
  | SetSavedAddressesAction
  | SetSavedCartAction
  | SetSelectedPaymentMethodAction
  | SetShippingOptionMethodAction
  | SetUserProfileAction;

export const cartReducer: (state: CartState, action: CartAction) => CartState = (state, action) => {
  let nextState: CartState;

  switch (action.type) {
    case "setCartStep":
      nextState = setCartStep(state, action);
      break;
    case "setDeliveryAddress":
      nextState = setDeliveryAddress(state, action);
      break;
    case "setDeliveryMode":
      nextState = setDeliveryMode(state, action);
      break;
    case "setDisabledCart":
      nextState = setDisabledCart(state, action);
      break;
    case "setDraftsNumber":
      nextState = setDraftsNumber(state, action);
      break;
    case "setSavedAddresses":
      nextState = setSavedAddresses(state, action);
      break;
    case "setSavedCart":
      nextState = setSavedCart(state, action);
      break;
    case "setSelectedPaymentMethod":
      nextState = setSelectedPaymentMethod(state, action);
      break;
    case "setShippingOptionMethod":
      nextState = setShippingOptionMethod(state, action);
      break;
    case "setUserProfile":
      nextState = setUserProfile(state, action);
      break;
    default:
      const exhaustiveCheck: never = action;
      throw new Error(`Unsupported type ${(exhaustiveCheck as { type: string }).type}`);
  }

  return nextState;
};

export type DispatchCartAction = Dispatch<CartAction>;
